import React, { PureComponent } from "react";
import TableCell from "./TableCell";

const layerStyles = {
  position: "fixed",
  pointerEvents: "none",
  zIndex: 100,
  left: 0,
  top: 0,
  cursor: "move",
  display: "none",
};

class DraggingPreview extends PureComponent {
  render() {
    const { data, columns, selectedRows, selectable } = this.props;

    return (
      <div ref={this.props.forwardedRef} style={layerStyles}>
        <table
          className="table table-hover table-bordered table-sm dnd-table"
          style={{ backgroundColor: "white" }}>
          <tbody>
            {data
              .filter(({ id }) => selectedRows.includes(id))
              .map(row => (
                <tr className="dnd-table-row" key={row.id}>
                  {selectable && (
                    <td
                      style={{ textAlign: "center", width: "5%", minWidth: 35 }}
                      className="dnd-table-cell">
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(row.id)}
                        onChange={() => {}}
                      />
                    </td>
                  )}
                  {columns.map(column => (
                    <TableCell
                      key={column.title}
                      {...column}
                      content={row[column.dataField]}
                      row={row}
                    />
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default DraggingPreview;
